import { formatMessage as f } from '@/i18n';

export default () => ({
  1: f('hardware.wm.1'),
  254: f('hardware.wm.254'),
  255: f('hardware.wm.255'),
  3001: f('hardware.wm.3001'),
  3005: f('hardware.wm.3005'),
  4096: f('hardware.wm.4096'),
  4097: f('hardware.wm.4097'),
  4098: f('hardware.wm.4098'),
  4099: f('hardware.wm.4099'),
  4100: f('hardware.wm.4100'),
  4101: f('hardware.wm.4101'),
  4102: f('hardware.wm.4102'),
  4105: f('hardware.wm.4105'),
  4106: f('hardware.wm.4106'),
  4108: f('hardware.wm.4108'),
  4109: f('hardware.wm.4109'),
  4110: f('hardware.wm.4110'),
  4111: f('hardware.wm.4111'),
  4113: f('hardware.wm.4113'),
  4114: f('hardware.wm.4114'),
  4115: f('hardware.wm.4115'),
  4117: f('hardware.wm.4117'),
  4118: f('hardware.wm.4118'),
  4122: f('hardware.wm.4122'),
  2003: f('hardware.wm.2003'),
});
